import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import ReviewPage from './components/ReviewPage';
import GigLandingPage from './components/GigLandingPage';
import ConsultantLandingPage from './components/ConsultantLandingPage';
import InfluencerLandingPage from './components/InfluencerLandingPage';
import PersonalFinanceLandingPage from './components/PersonalFinanceLandingPage';
import TermsPage from './components/TermsPage';
import PrivacyPage from './components/PrivacyPage';
import { AuthProvider } from './contexts/AuthContext';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Capture the PWA install prompt as early as possible — before React even mounts.
window.__pwaInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
  window.dispatchEvent(new Event('pwaInstallReady'));
});

const pathname     = window.location.pathname;
const params = new URLSearchParams(window.location.search);
const reviewLinkId = params.get('review');
const pageParam    = params.get('page');

// Persona landing pages are rendered without auth context.
// They navigate into the app by replacing the URL param.
function navigateToApp(screen) {
  window.history.replaceState({}, '', window.location.pathname);
  window.__initialAuthScreen = screen;
}

const rootElement = document.getElementById('root');
let appRoot = null;

const PERSONA_PAGES = {
  gig:        GigLandingPage,
  consultant: ConsultantLandingPage,
  influencer: InfluencerLandingPage,
  personal:   PersonalFinanceLandingPage,
};
const PersonaPage = PERSONA_PAGES[pageParam];

function renderApp(screen) {
  navigateToApp(screen);
  const ui = <React.StrictMode><AuthProvider><App /></AuthProvider></React.StrictMode>;
  if (appRoot) {
    appRoot.render(ui);
  } else {
    appRoot = createRoot(rootElement);
    appRoot.render(ui);
  }
}

const initialUI = (
  <React.StrictMode>
    {pathname === '/terms'
      ? <TermsPage standalone />
      : pathname === '/privacy'
        ? <PrivacyPage standalone />
        : reviewLinkId
          ? <ReviewPage linkId={reviewLinkId} />
          : PersonaPage
            ? <PersonaPage
                onSignUp={()  => renderApp('signup')}
                onSignIn={()  => renderApp('login')}
                onSkip={()    => renderApp('skip')}
                onPricing={() => renderApp('pricing')}
              />
            : <AuthProvider><App /></AuthProvider>
    }
  </React.StrictMode>
);

// Use hydrateRoot when react-snap has pre-rendered the page, createRoot otherwise.
if (rootElement.hasChildNodes()) {
  appRoot = hydrateRoot(rootElement, initialUI);
} else {
  appRoot = createRoot(rootElement);
  appRoot.render(initialUI);
}

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), { once: true });
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});
reportWebVitals();
